
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import Button from '../../../../../../utils/components/Button/Button'
import useModal from '../../../../../../utils/hooks/useModal'
import { deleteCategoryProduct } from '../../../../../actions/pCategoriesActions'
import { Table } from '../../../../../components/Table/Table'
import styles from './CategoriesList.module.css'

const CategoriesList = ({ categories, isEdit, formik, setIsEdit }) => {
    const history = useHistory()
    const [ref, isShowModal, setIsShowModal] = useModal(false)
    const [category, setCategory] = useState(null)
    return (
        <div>
            <div className={styles.input_container}>
                <input type="text" name="name" value={formik.values.name}
                    onChange={formik.handleChange} />
                <Button text={`${isEdit ? 'editar' : 'crear'}`} onClick={formik.handleSubmit} />
            </div>
            <div className={styles.grid_presentations}>
                {

                    categories.map(category => (
                        <div key={category._id} className={styles.presentation_card}>
                            {category.name}
                            <div className={styles.presentation_card_btn}>
                                <Button styles={{ width: "50%" }} text='Editar' onClick={() => {
                                    setIsEdit(true)
                                    formik.setFieldValue('name', category.name)
                                    formik.setFieldValue('id', category._id)
                                    //setPresentation(presentation.name)
                                    //  setPresentationId(presentation._id)
                                }} />
                                <Button styles={{ width: "50%" }} text='Eliminar' onClick={()=>{
                                    setCategory(category)
                                    setIsShowModal(true)
                                }}/>
                                <Button styles={{ width: "50%" }} onClick={() => history.push(`/Admin/Inventory/Categories/${category._id}`)} text='Ver sub categorías' />
                            </div>
                        </div>
                    ))
                }
            </div>

            <Modal category={category} displayModal={isShowModal} close={() => setIsShowModal(false)} />
        </div>
    )
    
}
const Modal = ({ category, displayModal, close }) => {
    const dispatch = useDispatch()
    const divStyle = {
        display: displayModal ? 'block' : 'none'
    }
    if (!category) {
        return <></>
    }
    return (
        <div className={"modal"} style={divStyle}>
            <div className="modal-content">
                <div>¿Está seguro que quiere borrar la sub-categoría ?: {category.name}</div>
                <Button styles={{ width: "50%" }} 
                onClick={() => {dispatch(deleteCategoryProduct(category._id,close))}} 
                text='Eliminar' />
                <Button styles={{ width: "50%" }} 
                onClick={() => {close()}}
                text='Cancelar' />
            </div>
  
        </div>
    )}
export default CategoriesList
